
import Vue from "vue";
import {Contact} from "@/models/base";
import AppExtraFields from "@/components/ExtraFieldsEdit.vue";
import {ExtraFieldNamesConfig} from "@/models/dossier-configs/extra-field-names-config";
import {DossierConfigService} from "@/services/dossier-config-service";
import {AuthService} from "@/services/auth-service";
import {MODULE} from "@/config/modules";
import {IClientStats} from "@/utils/client-stats";
import {getContactServiceByGroupId} from "@/utils/services/contact-services";
import {TranslateResult} from "vue-i18n";
import { UserConfigService } from "@/services";

export default Vue.extend({
	data() {
		return {
			activeTab: 0
		};
	},
	props: {
		contact: {type: Object as () => Contact},
		clientStats: {type: Object as () => IClientStats},
		defaultTab: Number
	},
	computed: {
		contactInfoDisplay(): string {
			if (!this.contact.Info) return "";
			return this.contact.Info.replaceAll("{__NEW_LINE__}", "\n").replaceAll("{__DOUBLE_SPACE__}", "  ");
		},
		isAllowed(): Boolean {
			return AuthService.hasModule(MODULE.EXTRA_VELDEN);
		},
		settings(): ExtraFieldNamesConfig {
			if (this.contact?.GroupID == 1) {
				return DossierConfigService.getExtraFieldNamesConfigs().ClientNames;
			}
			if (this.contact?.GroupID == 2) {
				return DossierConfigService.getExtraFieldNamesConfigs().SupplierNames;
			}
			return DossierConfigService.getExtraFieldNamesConfigs().ProspectNames;
		},
		tabs(): TranslateResult[] {
			let tabs = Object.values(this.$ct("extra-info-tabs"));
			return tabs;
		},
		showEditor():Boolean {
			return (UserConfigService.getSaleSettings().DescriptionEditor);
		},
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		updateContactInfo(value: string) {
			this.contact.Info = (value || "").replaceAll("\n", "{__NEW_LINE__}").replaceAll("  ", "{__DOUBLE_SPACE__}");
		},
		async update() {
			let contactService = getContactServiceByGroupId(this.contact.GroupID);
			await contactService.putContact(this.contact);
			this.$emit("cancel");
		},
		onInput(value: string){
			let regex = /style="(.*?)"/gm;
			value = value.replace(regex, "");
			//value = value.replace(/(?:\r\n)/g, "<br>");
			value = value.replaceAll(/<\/?span[^>]*>/g, "");
			value = value.replaceAll("<blockquote >", "<blockquote>");
			value = value.replaceAll("<br>", "{__NEW_LINE__}");
			value = value.replaceAll("<br >", "{__NEW_LINE__}");
			value = value.replaceAll("<div>", "{__NEW_LINE__}");
			value = value.replaceAll("</div>", "");
			value = value.replaceAll("&nbsp;&nbsp;", "{__DOUBLE_SPACE__}");
			this.contact.Info = value;
		},
	},
	mounted(){
		if (this.defaultTab >= 0 && this.defaultTab <= 1) {
			this.activeTab = this.defaultTab;
		}
	},
	components: {
		AppExtraFields
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
